<section class="sso-login-shell">
  <div class="sso-login-card">
    <h1>{{ title }}</h1>

    @if (status() === 'loading') {
      <mat-progress-spinner mode="indeterminate" diameter="44"></mat-progress-spinner>
      <p>{{ message() }}</p>
    } @else {
      <p>{{ message() }}</p>
      <button type="button" mat-flat-button color="primary" (click)="goToLogin()">
        Go to Login
      </button>
    }
  </div>
</section>
